export const notificationItemStyle = {
	title: {
		fontWeight: 'bold',
	},
	disableTitle: {
		color: 'var(--neutral-300)',
	},
	wrapperItem: {
		display: 'flex',
		padding: '8px 16px',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	content: {
		flex: 1,
		minWidth: 0,
	},
	description: {
		color: 'var(--neutral-300)',
		fontWeight: 'regular',
	},
	button: {
		whiteSpace: 'nowrap',
		padding: '0 32px',
	},
};
